import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculadora-promedios',
  templateUrl: './calculadora-promedios.component.html',
  styleUrls: ['./calculadora-promedios.component.css']
})
export class CalculadoraPromediosComponent implements OnInit {
  // Toggle for GUP/DAN mode
  isDanMode: boolean = false;

  // Forma inputs
  forma1: number | null = null;
  forma2: number | null = null;
  forma3: number | null = null;
  forma4: number | null = null;
  forma5: number | null = null;

  // Combate inputs
  combate1p: number | null = null;
  combate2p: number | null = null;
  combate3p: number | null = null;

  // Rotura inputs (all optional)
  rotura1: number | null = null;
  rotura2: number | null = null;
  rotura3: number | null = null;

  // Lucha inputs
  luchaTecnica: number | null = null;
  luchaEstrategia: number | null = null;
  luchaActitud: number | null = null;

  // Other inputs
  combinacion: number | null = null;
  ejerciciosEsp: number | null = null;
  teoria: number | null = null;

  // Promedio results
  promedioForma: number = 0;
  promedioCombate: number = 0;
  promedioRotura: number = 0;
  promedioLucha: number = 0;
  promedioFinal: number = 0;

  constructor() { }

  ngOnInit(): void {
    // Initialize with empty values
    this.calcular();
  }

  toggleMode(): void {
    // When switching modes, reset unused fields if switching to GUP mode
    if (!this.isDanMode) {
      // We're switching to GUP mode, clear extra fields
      this.forma2 = null;
      this.forma3 = null;
      this.forma4 = null;
      this.forma5 = null;
      
      this.combate2p = null;
      this.combate3p = null;
      
      this.rotura2 = null;
      this.rotura3 = null;
      
      this.luchaEstrategia = null;
      this.luchaActitud = null;
    }
    
    // Recalculate after mode change
    this.calcular();
  }

  calcular(): void {
    // GUP mode calculation logic - only consider single values for each category
    if (!this.isDanMode) {
      // In GUP mode, only consider forma1, combate1p, rotura1, and luchaTecnica
      this.promedioForma = this.forma1 || 0;
      this.promedioCombate = this.combate1p || 0;
      this.promedioRotura = this.rotura1 || 0;
      this.promedioLucha = this.luchaTecnica || 0;
    } else {
      // DAN mode - use the original average calculations
      // Calculate Forma average
      let formaSum = 0;
      let formaCount = 0;
      
      if (this.forma1 !== null) { formaSum += this.forma1; formaCount++; }
      if (this.forma2 !== null) { formaSum += this.forma2; formaCount++; }
      if (this.forma3 !== null) { formaSum += this.forma3; formaCount++; }
      if (this.forma4 !== null) { formaSum += this.forma4; formaCount++; }
      if (this.forma5 !== null) { formaSum += this.forma5; formaCount++; }
      
      this.promedioForma = formaCount > 0 ? formaSum / formaCount : 0;
      
      // Calculate Combate average
      let combateSum = 0;
      let combateCount = 0;
      
      if (this.combate1p !== null) { combateSum += this.combate1p; combateCount++; }
      if (this.combate2p !== null) { combateSum += this.combate2p; combateCount++; }
      if (this.combate3p !== null) { combateSum += this.combate3p; combateCount++; }
      
      this.promedioCombate = combateCount > 0 ? combateSum / combateCount : 0;
      
      // Calculate Rotura average (optional)
      let roturaSum = 0;
      let roturaCount = 0;
      
      if (this.rotura1 !== null) { roturaSum += this.rotura1; roturaCount++; }
      if (this.rotura2 !== null) { roturaSum += this.rotura2; roturaCount++; }
      if (this.rotura3 !== null) { roturaSum += this.rotura3; roturaCount++; }
      
      this.promedioRotura = roturaCount > 0 ? roturaSum / roturaCount : 0;
      
      // Calculate Lucha average
      let luchaSum = 0;
      let luchaCount = 0;
      
      if (this.luchaTecnica !== null) { luchaSum += this.luchaTecnica; luchaCount++; }
      if (this.luchaEstrategia !== null) { luchaSum += this.luchaEstrategia; luchaCount++; }
      if (this.luchaActitud !== null) { luchaSum += this.luchaActitud; luchaCount++; }
      
      this.promedioLucha = luchaCount > 0 ? luchaSum / luchaCount : 0;
    }
    
    // Calculate final average - same for both modes
    let finalSum = 0;
    let finalCount = 0;
    
    // Add promedioForma if available
    if (this.promedioForma > 0) { 
      finalSum += this.promedioForma; 
      finalCount++; 
    }
    
    // Add promedioCombate if available
    if (this.promedioCombate > 0) { 
      finalSum += this.promedioCombate; 
      finalCount++; 
    }
    
    // Add combinacion if available
    if (this.combinacion !== null) { 
      finalSum += this.combinacion; 
      finalCount++; 
    }
    
    // Add ejerciciosEsp if available
    if (this.ejerciciosEsp !== null) { 
      finalSum += this.ejerciciosEsp; 
      finalCount++; 
    }
    
    // Add promedioRotura if available (optional)
    if (this.promedioRotura > 0) { 
      finalSum += this.promedioRotura; 
      finalCount++; 
    }
    
    // Add promedioLucha if available
    if (this.promedioLucha > 0) { 
      finalSum += this.promedioLucha; 
      finalCount++; 
    }
    
    // Add teoria if available
    if (this.teoria !== null) { 
      finalSum += this.teoria; 
      finalCount++; 
    }
    
    // Calculate final average
    this.promedioFinal = finalCount > 0 ? finalSum / finalCount : 0;
  }

  limpiarFormulario(): void {
    // Reset all inputs
    this.forma1 = null;
    this.forma2 = null;
    this.forma3 = null;
    this.forma4 = null;
    this.forma5 = null;
    
    this.combate1p = null;
    this.combate2p = null;
    this.combate3p = null;
    
    this.rotura1 = null;
    this.rotura2 = null;
    this.rotura3 = null;
    
    this.luchaTecnica = null;
    this.luchaEstrategia = null;
    this.luchaActitud = null;
    
    this.combinacion = null;
    this.ejerciciosEsp = null;
    this.teoria = null;
    
    // Reset results
    this.promedioForma = 0;
    this.promedioCombate = 0;
    this.promedioRotura = 0;
    this.promedioLucha = 0;
    this.promedioFinal = 0;
  }

  imprimirResultado(): void {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Por favor, permita las ventanas emergentes para imprimir');
      return;
    }

    // Create HTML with appropriate fields based on GUP/DAN mode
    const modeText = this.isDanMode ? 'DAN' : 'GUP';
    
    // Create a simple HTML for printing
    printWindow.document.write(`
      <html>
        <head>
          <title>Calculadora de Promedios - Taekwondo (${modeText})</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { text-align: center; }
            .section { margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { padding: 8px; text-align: left; border-bottom: 1px solid #ddd; }
            .result { font-weight: bold; margin-top: 20px; font-size: 18px; }
          </style>
        </head>
        <body>
          <h1>Calculadora de Promedios - Taekwondo (${modeText})</h1>
    `);
    
    // Add forma section
    printWindow.document.write(`
      <div class="section">
        <h2>Forma</h2>
        <table>
          <tr>
    `);

    // Add headers based on mode
    printWindow.document.write(`<th>Forma 1</th>`);
    if (this.isDanMode) {
      printWindow.document.write(`
        <th>Forma 2</th>
        <th>Forma 3</th>
        <th>Forma 4</th>
        <th>Forma 5</th>
      `);
    }
    printWindow.document.write(`<th>Promedio</th></tr><tr>`);
            
    // Add values based on mode
    printWindow.document.write(`<td>${this.forma1 || '-'}</td>`);
    if (this.isDanMode) {
      printWindow.document.write(`
        <td>${this.forma2 || '-'}</td>
        <td>${this.forma3 || '-'}</td>
        <td>${this.forma4 || '-'}</td>
        <td>${this.forma5 || '-'}</td>
      `);
    }
    printWindow.document.write(`<td>${this.promedioForma.toFixed(2)}</td></tr></table></div>`);

    // Add other sections similarly
    printWindow.document.write(`
      <div class="section">
        <h2>Combate</h2>
        <table>
          <tr>
            <th>Combate 1 Paso</th>
    `);
    if (this.isDanMode) {
      printWindow.document.write(`
            <th>Combate 2 Pasos</th>
            <th>Combate 3 Pasos</th>
      `);
    }
    printWindow.document.write(`
            <th>Promedio</th>
          </tr>
          <tr>
            <td>${this.combate1p || '-'}</td>
    `);
    if (this.isDanMode) {
      printWindow.document.write(`
            <td>${this.combate2p || '-'}</td>
            <td>${this.combate3p || '-'}</td>
      `);
    }
    printWindow.document.write(`
            <td>${this.promedioCombate.toFixed(2)}</td>
          </tr>
        </table>
      </div>
    `);

    printWindow.document.write(`
      <div class="section">
        <h2>Rotura</h2>
        <table>
          <tr>
            <th>Rotura 1</th>
    `);
    if (this.isDanMode) {
      printWindow.document.write(`
            <th>Rotura 2</th>
            <th>Rotura 3</th>
      `);
    }
    printWindow.document.write(`
            <th>Promedio</th>
          </tr>
          <tr>
            <td>${this.rotura1 || '-'}</td>
    `);
    if (this.isDanMode) {
      printWindow.document.write(`
            <td>${this.rotura2 || '-'}</td>
            <td>${this.rotura3 || '-'}</td>
      `);
    }
    printWindow.document.write(`
            <td>${this.promedioRotura.toFixed(2)}</td>
          </tr>
        </table>
      </div>
    `);

    printWindow.document.write(`
      <div class="section">
        <h2>Lucha</h2>
        <table>
          <tr>
            <th>Técnica</th>
    `);
    if (this.isDanMode) {
      printWindow.document.write(`
            <th>Estrategia</th>
            <th>Actitud</th>
      `);
    }
    printWindow.document.write(`
            <th>Promedio</th>
          </tr>
          <tr>
            <td>${this.luchaTecnica || '-'}</td>
    `);
    if (this.isDanMode) {
      printWindow.document.write(`
            <td>${this.luchaEstrategia || '-'}</td>
            <td>${this.luchaActitud || '-'}</td>
      `);
    }
    printWindow.document.write(`
            <td>${this.promedioLucha.toFixed(2)}</td>
          </tr>
        </table>
      </div>
    `);

    printWindow.document.write(`
      <div class="section">
        <h2>Otros</h2>
        <table>
          <tr>
            <th>Combinación</th>
            <th>Ejercicios Especiales</th>
            <th>Teoría</th>
          </tr>
          <tr>
            <td>${this.combinacion || '-'}</td>
            <td>${this.ejerciciosEsp || '-'}</td>
            <td>${this.teoria || '-'}</td>
          </tr>
        </table>
      </div>
    `);

    // Add final result
    printWindow.document.write(`
          <div class="result">
            Promedio Final: ${this.promedioFinal.toFixed(2)}
          </div>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 500);
  }
}
